"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getChatbotHost = getChatbotHost;
function getChatbotHost(config) {
  var domainPrefix = config.env === 'live' ? '' : config.env === 'liveish' ? 'live-test.' : "".concat(config.env, ".");
  var CHATBOT_SUBDOMAIN_PREFIX = 'chatbot.';
  return "https://".concat(CHATBOT_SUBDOMAIN_PREFIX).concat(domainPrefix, "shopee.sg");
}